import Masonry from 'masonry-layout';

// Masonry positions every item absolutely, once, from the heights it measured at
// load — so an item that grows later (the newsletter card's status message, a
// late image) overlaps its neighbour until layout() runs again. Watch the items
// and re-run it; layout() only moves items, so it can't retrigger the observer.
let itemObserver = null;
let relayoutQueued = false;

function relayoutMasonry() {
  const container = document.querySelector('[data-masonry]');
  const msnry = container && Masonry.data(container);
  if (msnry) {
    msnry.layout();
  }
}

function watchItems(container) {
  if (!container || !window.ResizeObserver) {
    return;
  }
  if (!itemObserver) {
    itemObserver = new ResizeObserver(() => {
      if (relayoutQueued) {
        return;
      }
      relayoutQueued = true;
      // Coalesce a burst of resizes into one layout, after the browser has
      // finished the frame that resized them.
      window.requestAnimationFrame(() => {
        relayoutQueued = false;
        relayoutMasonry();
      });
    });
  }
  itemObserver.disconnect();
  Array.from(container.children).forEach((item) => itemObserver.observe(item));
}

// Swap a poster facade for the real player. Until this runs the provider has had no
// request at all, so a visitor who never clicks stays invisible to it.
function playVideo(facade) {
  const src = facade.dataset.videoSrc;
  let url;
  try {
    url = new URL(src, window.location.href);
  } catch (error) {
    console.error('Invalid video embed URL:', src, error);
    return;
  }
  url.searchParams.set('autoplay', '1');

  const iframe = document.createElement('iframe');
  iframe.src = url.toString();
  iframe.title = facade.getAttribute('aria-label') || '';
  iframe.allow = 'autoplay; fullscreen; encrypted-media';
  iframe.referrerPolicy = 'strict-origin-when-cross-origin';
  iframe.allowFullscreen = true;
  iframe.loading = 'lazy';

  facade.replaceChildren(iframe);
  facade.classList.remove('video-facade');
  [ 'role', 'tabindex', 'aria-label' ].forEach((attr) => facade.removeAttribute(attr));
  iframe.focus();
}

function onFacadeActivate(event) {
  const facade = event.target.closest && event.target.closest('.video-facade[data-video-src]');
  if (!facade) {
    return;
  }
  if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
    return;
  }
  // The whole card is a link to the post, so playing must not navigate — and Space
  // must not scroll.
  event.preventDefault();
  event.stopPropagation();
  playVideo(facade);
}

export default () => {
  // Delegated, so the cards loadMore() appends are covered without rebinding.
  document.addEventListener('click', onFacadeActivate);
  document.addEventListener('keydown', onFacadeActivate);

  apos.util.onReady(() => {
    const loadMoreBtn = document.querySelector('[data-apos-load-more]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', loadMore);
    }
    watchItems(document.querySelector('[data-masonry]'));
    // TODO: impplement infinite scrolling, see: https://apostrophecms.com/blog/htmx-examples-and-how-to-use-it
    // window.addEventListener('scroll', handleScroll);
  });

  // function handleScroll() {
  //   if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500) {
  //     loadMore();
  //   }
  // }

  async function loadMore() {
    const currentPage = parseInt(this.dataset.currentPage || 1);
    const nextPage = currentPage + 1;

    try {
      const response = await apos.http.get(window.location.href, {
        qs: {
          page: nextPage,
          aposRefresh: 1,
          showOnlyList: 1
        }
      });

      const blogList = document.querySelector('[data-apos-ajax-context="blog-list"]');
      blogList.insertAdjacentHTML('beforeend', response);
      const masonryContainer = document.querySelector('[data-masonry]');
      if (masonryContainer) {
        const msnry = Masonry.data(masonryContainer);
        if (msnry) {
          msnry.reloadItems();
          msnry.layout();
        }
        // The appended cards need watching too.
        watchItems(masonryContainer);
      }

      if (blogList.querySelector('[data-apos-load-more-end]')) {
        const loadMoreDiv = document.querySelector('[data-apos-load-more-block]');
        if (loadMoreDiv) {
          loadMoreDiv.classList.add('d-none');
        }
      }

      this.dataset.currentPage = nextPage;
    } catch (error) {
      console.error('Error loading more posts:', error);
    }
  }
};
